import React, { PureComponent } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import { Text } from 'trpc-react-native-ui';
import { PickLine } from '../../components/common';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import type { StateProps, DispatchProps } from '../../components/common/PickLine/PickLine';

export default class PickLineForRioNumber extends PureComponent<Props> {
  styles = getStyles();
  renderSubscriptions() {
    return <PickLine {...this.props} />;
  }
  renderNoSubscription() {
    return (
      <SafeAreaView style={this.styles.emptyContainer}  edges={['bottom', 'left', 'right']}>
        <Image source={theme.lostAndStolenImage} style={this.styles.image} />
        <Text style={this.styles.emptyText}>{I18n.t('Dashboard.GetRioNumber.empty')}</Text>
      </SafeAreaView>
    );
  }
  render() {
    return this.props.subscriptions.length ? this.renderSubscriptions() : this.renderNoSubscription();
  }
}

type Props = StateProps & DispatchProps;

const getStyles = () =>
  StyleSheet.create({
    emptyContainer: {
      alignItems: 'center',
      flex: 1,
      justifyContent: 'center',
    },
    emptyText: {
      color: theme.emptyTextColor,
      fontSize: 16,
      marginBottom: 75,
      textAlign: 'center',
    },
    image: {
      height: 100,
      marginTop: 16,
      marginBottom: 29,
      width: 100,
    },
  });
